var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localized)?_c(_vm.component,_vm._b({tag:"component"},'component',_vm.$props,false)):_c('ResponsiveImage',{staticClass:"logo",attrs:{"image-url":_vm.provider.logo,"width":"76px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }